<template>
  <v-row class="pt-10 pr-3 pl-3">
    <v-col v-if="item.channel.name === 'CALL'">
      <v-row class="pb-2">
        <v-col cols="3" class="py-0 pb-3">
          <div class="daktela-activity-label">Místní číslo</div>
          <div class="daktela-activity-value mt-2">
            {{ item.metadata.localNumber ? item.metadata.localNumber : '-' }}
          </div>
        </v-col>
        <v-col cols="3" class="py-0 pb-3">
          <div class="daktela-activity-label">Začátek hovoru</div>
          <div class="daktela-activity-value mt-2">
            <DateTime :datetime="item.metadata.createdAt" :single-line="true"></DateTime>
          </div>
        </v-col>
        <v-col cols="3" class="py-0 pb-3">
          <div class="daktela-activity-label">Odpověděl</div>
          <div class="daktela-activity-value mt-2">
            <YesNo :value="item.metadata.answered" />
          </div>
        </v-col>
      </v-row>
      <v-row class="pb-6">
        <v-col cols="3" class="py-0 pb-3">
          <div class="daktela-activity-label">Číslo zákazníka</div>
          <div class="daktela-activity-value mt-2">
            {{ item.metadata.callerNumber ? item.metadata.callerNumber : '-' }}
          </div>
        </v-col>
        <v-col cols="3" class="py-0 pb-3">
          <div class="daktela-activity-label">Konec hovoru</div>
          <div v-if="item.metadata.closedAt" class="daktela-activity-value mt-2">
            <DateTime :datetime="item.metadata.closedAt" :single-line="true"></DateTime>
          </div>
          <div v-else class="daktela-activity-value mt-2">-</div>
        </v-col>
      </v-row>
    </v-col>
    <v-col v-else-if="item.channel.name === 'EMAIL'">
      <v-row class="pb-2">
        <v-col cols="3" class="py-0 pb-3">
          <div class="daktela-activity-label">Předmět</div>
          <div class="daktela-activity-value mt-2">
            {{ item.metadata.subject }}
          </div>
        </v-col>
        <v-col cols="3" class="py-0 pb-3">
          <div class="daktela-activity-label">Odpověděl</div>
          <div class="daktela-activity-value mt-2">
            <YesNo :value="item.metadata.answered" />
          </div>
        </v-col>
        <v-col cols="6" class="py-0 pb-3 text-right">
          <v-btn
            color="primary"
            depressed
            small
            @click="openEmailContentViewDialog($event, item.metadata.text)"
          >
            Zobrazit obsah
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="pb-6">
        <v-col cols="4" class="py-0 pb-3">
          <div class="daktela-activity-label">E-mail</div>
          <div class="daktela-activity-value mt-2">
            {{ item.metadata.email }}
          </div>
        </v-col>
      </v-row>
    </v-col>
    <v-col v-else-if="item.channel.name === 'SMS'">
      <v-row class="pb-6">
        <v-col cols="3" class="py-0 pb-3">
          <div class="daktela-activity-label">Odpověděl</div>
          <div class="daktela-activity-value mt-2">
            <YesNo :value="item.metadata.answered" />
          </div>
        </v-col>
      </v-row>
    </v-col>
    <v-col v-else-if="item.channel.name === 'FBM'">
      <v-row class="pb-6">
        <v-col cols="3" class="py-0 pb-3">
          <div class="daktela-activity-label">Odpověděl</div>
          <div class="daktela-activity-value mt-2">
            <YesNo :value="item.metadata.answered" />
          </div>
        </v-col>
      </v-row>
    </v-col>
    <v-col v-else> </v-col>
    <EmailContentViewDialog />
  </v-row>
</template>

<script>
import YesNo from '../YesNo.vue'
import EmailContentViewDialog from '../EmailContentViewDialog.vue'
import DateTime from '../DateTime.vue'

export default {
  name: 'CustomerDaktelaActivityMetadata',
  components: { DateTime, EmailContentViewDialog, YesNo },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    openEmailContentViewDialog(event, content) {
      this.$eventBus.$emit('emailContentViewDialog', true, content)
    },
  },
}
</script>
